import { StreamStatus } from 'api/graphql-global-types';
import { STREAM_CHECKOUT } from 'constants/routes';
import {
  computeOrderStreamPath,
  computeVideoWatchStreamPath,
} from 'helpers/routes';
import { isStartStreamButtonDisabled } from 'helpers/streams';

export type StreamNavigationInput = {
  id?: string | null;
  slug?: string | null;
  isFree?: boolean | null;
  isPurchased?: boolean | null;
  streamStatus?: StreamStatus | null;
  scheduleDate?: string | null;
  timeZone?: { offset?: number | null } | null;
  store?: { id?: string | null; slug?: string | null } | null;
};

export const getStreamNavigationPath = (
  stream: StreamNavigationInput,
  loggedUserId: string | null,
  toCheckout?: boolean
): string => {
  const isScheduled = stream?.streamStatus === StreamStatus.Scheduled;
  const canWatch =
    stream?.isFree || stream?.isPurchased || stream?.store?.id === loggedUserId;

  if (canWatch) {
    if (
      isScheduled &&
      isStartStreamButtonDisabled(
        stream as Parameters<typeof isStartStreamButtonDisabled>[0]
      )
    ) {
      return computeOrderStreamPath(
        stream as Parameters<typeof computeOrderStreamPath>[0]
      );
    }

    return computeVideoWatchStreamPath(
      stream as Parameters<typeof computeVideoWatchStreamPath>[0]
    );
  }

  if (!stream?.isFree && toCheckout && loggedUserId && stream?.id) {
    return `${STREAM_CHECKOUT}/${stream.id}/information`;
  }

  return computeOrderStreamPath(
    stream as Parameters<typeof computeOrderStreamPath>[0]
  );
};
